import React from "react";

import { Tag } from "antd";

import {
  CarryOutOutlined, CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, FieldTimeOutlined, PauseOutlined, ReloadOutlined,
} from "@ant-design/icons";
import {
  REPORT_STATUS_FLAGS,
  ML_SOFTWARE_QC_FLAGS,
  BATCH_REPORT_TEST_STATUS,
  BATCH_REPORT_GENERATE_STATUS,
  MANUAL_QC_FLAGS,
} from "../../../utils/statusConfig";

import "./StatusTag.css";

const reportStatusIcons = {
  0: <FieldTimeOutlined />,
  1: <CarryOutOutlined />,
  2: <PauseOutlined />,
  3: <ReloadOutlined />,
};

const qcStatusIcons = {
  "-1": <ExclamationCircleOutlined />,
  0: <FieldTimeOutlined />,
  1: <CheckCircleOutlined />,
  2: <ExclamationCircleOutlined />,
  3: <ClockCircleOutlined />,
};

// Helper to get flags based on type
const getFlags = (type, key) => {
  if (type === "TEST_STATUS") {
    return BATCH_REPORT_TEST_STATUS[key];
  }
  if (type === "GENERATE_STATUS") {
    return BATCH_REPORT_GENERATE_STATUS[key];
  }
  if (type === "QC") {
    return ML_SOFTWARE_QC_FLAGS[key];
  }
  if (type === "MANUAL_QC") {
    return MANUAL_QC_FLAGS[key];
  }
  return REPORT_STATUS_FLAGS[key];
};

export default function StatusTag({
  result,
  type,
  children,
}) {
  const isQc = type === "QC";
  const isTestStatus = type === "TEST_STATUS";
  const isGenerateStatus = type === "GENERATE_STATUS";
  const isManualQc = type === "MANUAL_QC";
  let key = result;
  if (!result && result !== 0) {
    key = "-";
  }
  const flags = getFlags(type, key);
  const style = flags?.style || {};
  const status = flags?.status;
  const label = flags?.label ?? "-";

  // Determine display label (QC uses status e.g. "Passed"/"Failed", others use label)
  let displayLabel;
  if (isTestStatus || isGenerateStatus) {
    displayLabel = label;
  } else if (isQc || isManualQc) {
    displayLabel = status ?? label ?? "-";
  } else {
    displayLabel = label;
  }

  // Determine which icon to show
  let icon;
  if (isTestStatus || isGenerateStatus) {
    icon = <ClockCircleOutlined />;
  } else if (isQc || isManualQc) {
    let qcKey = 0;
    if (result != null && result !== "") {
      qcKey = (result === -1 || result === "-1") ? "-1" : Number(result);
    }
    icon = qcStatusIcons[qcKey] ?? qcStatusIcons[0];
  } else {
    icon = reportStatusIcons[result ?? 0];
  }

  const getLabelLength = (labelText) => {
    if (!labelText) return "";
    if (labelText.length > 9) return "long";
    return "";
  };

  return (
    <Tag className="StatusTag" style={style} data-label-length={getLabelLength(displayLabel)}>
      <span className="content">
        {icon}
        <span className="text">{displayLabel}</span>
      </span>
      {children}
    </Tag>
  );
}
